/**
 * Single source of truth for all registration collections and competition metadata.
 * Used by both AdminPanel (full fetch) and analytics (lean fetch).
 */

export const REGISTRATION_COLLECTIONS = [
  "registrations_algorithm",
  "registrations_real-world_problem_solving",
  "registrations_web_development",
  "registrations_photo_manipulation",
  "registrations_poster_design",
  "registrations_logo_design",
  "registrations_ui_ux_design",
  "registrations_fastest_line_following_bot",
  "registrations_innovation_challenge",
  "registrations_inter_school_quiz",
  "ict_society_registrations",
  "competition_registrations",
];

// Fields that hold the submission time, per collection
export const TIMESTAMP_FIELD = {
  ict_society_registrations: "timestamp",
  default: "submittedAt",
};

/**
 * Metadata for each collection.
 * title          – human-readable competition name
 * competitionSchool – hosting pillar
 * isTeam         – whether it is a team event
 * hasParticipationType – whether participationType (intra/inter) is collected
 */
export const COMPETITION_META = {
  registrations_algorithm: {
    title: "Algorithm",
    competitionSchool: "Armitage",
    isTeam: false,
    hasParticipationType: true,
  },
  "registrations_real-world_problem_solving": {
    title: "Real-world Problem Solving",
    competitionSchool: "Armitage",
    isTeam: true,
    hasParticipationType: true,
  },
  registrations_web_development: {
    title: "Web Development",
    competitionSchool: "Armitage",
    isTeam: false,
    hasParticipationType: true,
  },
  registrations_photo_manipulation: {
    title: "Photo Manipulation",
    competitionSchool: "Insignia",
    isTeam: false,
    hasParticipationType: true,
  },
  registrations_poster_design: {
    title: "Poster Design",
    competitionSchool: "Insignia",
    isTeam: false,
    hasParticipationType: true,
  },
  registrations_logo_design: {
    title: "Logo Design",
    competitionSchool: "Insignia",
    isTeam: false,
    hasParticipationType: true,
  },
  registrations_ui_ux_design: {
    title: "UI/UX Design",
    competitionSchool: "Insignia",
    isTeam: false,
    hasParticipationType: true,
  },
  registrations_fastest_line_following_bot: {
    title: "Fastest Line Following Bot",
    competitionSchool: "Zenith",
    isTeam: true,
    hasParticipationType: true,
  },
  registrations_innovation_challenge: {
    title: "Innovation Challenge",
    competitionSchool: "Zenith",
    isTeam: true,
    hasParticipationType: true,
  },
  registrations_inter_school_quiz: {
    title: "Inter School Quiz",
    competitionSchool: "Orthodox",
    isTeam: true,
    hasParticipationType: true,
  },
  ict_society_registrations: {
    title: "Most Popular ICT Society",
    competitionSchool: "All",
    isTeam: false,
    hasParticipationType: false,
  },
  competition_registrations: {
    title: "Legacy",
    competitionSchool: "Unknown",
    isTeam: false,
    hasParticipationType: true,
  },
};

/** Ordered list of grade options (from CompetitionForm) */
export const GRADE_OPTIONS = [
  "6", "7", "8", "9", "10", "11", "After O/L", "12", "13",
];

export const HOSTING_SCHOOLS = ["Armitage", "Insignia", "Zenith", "Orthodox"];
